// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stat-card[data-v-37854ac4] { text-align: center;\n}\n.stat-label[data-v-37854ac4] { font-size: 13px; color: #909399; margin-bottom: 6px;\n}\n.stat-value[data-v-37854ac4] { font-size: 26px; font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
